/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Membership_Plan_Change_Blocked_Engagement_DowngradeInputs */

const fr_membership_plan_change_blocked_engagement_downgrade = /** @type {(inputs: Membership_Plan_Change_Blocked_Engagement_DowngradeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Indisponible pendant l'engagement (jusqu'au ${i?.date})`)
};

/**

* @param {Membership_Plan_Change_Blocked_Engagement_DowngradeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_blocked_engagement_downgrade = /** @type {((inputs: Membership_Plan_Change_Blocked_Engagement_DowngradeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_Blocked_Engagement_DowngradeInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_blocked_engagement_downgrade(inputs)
});